var map = {
	"./arrow-circle.svg": 9533,
	"./arrow.svg": 592,
	"./check.svg": 1495,
	"./chevron.svg": 9810,
	"./compass.svg": 1003,
	"./email.svg": 3219,
	"./facebook.svg": 5173,
	"./instagram.svg": 415,
	"./linkedin.svg": 3899,
	"./mailbox.svg": 1255,
	"./phone.svg": 6131,
	"./quote.svg": 4295,
	"./scroll-circle.svg": 3531,
	"./scroll-down.svg": 2007,
	"./twitter.svg": 386,
	"./webatvantage.svg": 4459,
	"./x.svg": 4051,
	"./youtube.svg": 472
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1082;